import { HTMLAttributes } from 'react'
import { MdDashboard, MdPeople } from 'react-icons/md'
import { FaFileAlt, FaBullhorn, FaPlus } from 'react-icons/fa'
import { ReactComponent as HelpCircleIcon } from 'assets/images/sidenav/help-circle.svg'
import { ReactComponent as DocVerificationIcon } from 'assets/images/sidenav/docVerification.svg'
import { ReactComponent as FCUser } from 'assets/images/sidenav/fcUser.svg'
import useAuth from '../hooks/Auth'

type SubMenuItemType = {
  id: string,
  name: string,
  link: string,
  icon?: React.FC<HTMLAttributes<SVGElement>>
}

type MenuItemType = {
  id: string,
  name: string,
  link?: string,
  icon: React.FC<HTMLAttributes<SVGElement>>,
  roles: string[],
  subMenu?: SubMenuItemType[]
}

const menuItems: MenuItemType[] = [
  {
    id: '1',
    name: 'Dashboard',
    link: '/',
    icon: MdDashboard,
    roles: ['ROLE_USER', 'ROLE_ADMIN']
  },
  {
    id: '2',
    name: 'Channel Onboard',
    link: '/channels',
    icon: FaPlus,
    roles: ['ROLE_USER', 'ROLE_ADMIN']
  },
  {
    id: '3',
    name: 'Templates',
    link: '/templates',
    icon: FaFileAlt,
    roles: ['ROLE_USER', 'ROLE_ADMIN']
  },
  {
    id: '4',
    name: 'Campaigns',
    link: '/campaigns',
    icon: FaBullhorn,
    roles: ['ROLE_USER', 'ROLE_ADMIN']
  },
  {
    id: '5',
    name: 'Audience',
    link: '/audience',
    icon: MdPeople,
    roles: ['ROLE_USER', 'ROLE_ADMIN']
  },
  {
    id: '6',
    name: 'Help',
    link: '/help',
    icon: HelpCircleIcon,
    roles: ['ROLE_USER']
  },
  {
    id: '7',
    name: 'Enquiry',
    link: '/enquiry',
    icon: HelpCircleIcon,
    roles: ['ROLE_ADMIN']
  },
  {
    id: '8',
    name: 'Doc Verification',
    link: '/document-verification',
    icon: DocVerificationIcon,
    roles: ['ROLE_ADMIN'],
    subMenu: [
      {
        id: '13-1',
        name: 'Company List',
        link: '/document-verification/company',
        icon: FCUser
      }
    ]
  }
]

export const getMenuItemsForRole = (roles: string[]): MenuItemType[] => {
  return menuItems.filter((item) =>
    item.roles.some((role) => roles.includes(role))
  )
}

export const useFilteredMenuItems = (): MenuItemType[] => {
  const { role } = useAuth()

  if (!role || role.length === 0) return []

  return getMenuItemsForRole(role)
}

export default menuItems
